import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.4.1_@types+node@20.17.10_db0@0.2.1_encoding@0.1.13_eslint@9._kdql75qdet4yxa5zs36b4g2rki/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  manifest_45route_45rule
]
export const namedMiddleware = {}